<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,

        props: {
            dateRanges: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            loading: false,
            chartdata: {
                labels: [],
                datasets: [
                    {
                        label: 'ยอดในการแลก',
                        backgroundColor: '#f87979',
                        data: []
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false
            }
        }),

        watch: {
            dateRanges: {
                deep: true,
                handler({fromDate, toDate}) {
                    this.load({fromDate, toDate})
                }
            }
        },

        async mounted () {
            try {
                await this.load(this.$props.dateRanges)
            } catch (e) {

            }
        },

        methods: {
            async load({fromDate, toDate}) {
                this.loading = true

                try {
                    const { data } = await axios.get(`/reports/chart-quantity`, {
                        params: {
                            from_date: fromDate,
                            to_date: toDate
                        }
                    })

                    const labels = [];
                    const items = [];

                    // Map date from array to object (by date)
                    // Like: {'2020-05-21': 25, '2020-05-22': 11}
                    const dataDateByGroup = _.groupBy(data.data, 'date')
                    Object.keys(dataDateByGroup).forEach((date) => {
                        dataDateByGroup[date] = dataDateByGroup[date][0].total
                    })

                    _.range(0, moment(toDate).diff(moment(fromDate), 'days')).forEach((dayNumber) => {
                        const unixFormat = 'YYYY-MM-DD'
                        const current = moment(fromDate).add(dayNumber, 'days')

                        labels.push(current.format('D/MMM/YY'))
                        items.push(parseInt(dataDateByGroup[current.format(unixFormat)] || 0))
                    })

                    this.chartdata.labels = labels
                    this.chartdata.datasets[0].data = items

                    this.renderChart(this.chartdata, this.options)

                } catch (e) {
                    //
                }

                this.loading = false
            }
        }
    }
</script>
